module.exports = __webpack_public_path__ + "static/media/usage_auto.085ee0ad.png";